import { Dexie } from "dexie";
import { v4 } from 'uuid';
export class Db extends Dexie {
    constructor() {
        super('db');
        this.version(3)
            .stores({
            tracks: 'id,created,updated,distance',
            tiles: 'id,layer'
        });
    }
}
export const db = new Db();
export const getTable = (table) => {
    return db[table];
};
export const insertItem = async (table, item) => {
    const insert = item;
    if (!insert.id)
        insert.id = v4();
    await getTable(table).add(insert, insert.id);
    return insert;
};
export const updateItem = async (table, id, update) => {
    await getTable(table).update(id, { ...update, updated: Date.now() });
};
